import { createAction } from 'typesafe-actions'
import ComparisonPdfPayload from '../../../entities/ComparisonPdfPayload'
import ErrorType from '../../../entities/ErrorType'
import { Action } from 'typesafe-actions'

export const createComparisonPdf = createAction('CMD / Comparison PDF / create')<ComparisonPdfPayload>()

export const comparisonPdfCreationFailed = createAction(
    'EVT / Comparison PDF / creation failed',
)<{ failureAction: Function; error: Error; type: ErrorType; url: string }, { causedBy: Action }>()
